import { createElement, forwardRef } from 'react';
import { Button as OriginalButton } from 'antd';
const Button = ({ type = 'primary', style = {}, ...otherProps }, ref) => {
    const _style = style || {};
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    if (!_otherProps.href?.trim() || _otherProps.__designMode === 'design') {
        _otherProps.href = undefined;
    }
    return (createElement(OriginalButton, Object.assign({ type: type }, _otherProps, { ref: ref }), otherProps.children));
};
Button.displayName = 'Button';
export default forwardRef(Button);
